// Donation list-item rendering (Tasks 13.3, 13.4, 13.5).
//
// Compact, card-style row for a Donation used in dashboard lists. Optional
// action buttons let the parent wire reserve/collect/cancel/delete actions.

import type { ReactNode } from "react";
import type { Donation } from "@sharebite/domain";

export function DonationRow({
  donation,
  actions,
}: {
  donation: Donation;
  actions?: ReactNode;
}): JSX.Element {
  return (
    <div className="sb-list-item">
      <div className="sb-row">
        <strong>{donation.foodName}</strong>
        <span className="sb-pill" data-cat={donation.foodCategory}>
          {donation.foodCategory}
        </span>
        <span className="sb-pill" data-status={donation.status}>
          {donation.status}
        </span>
        <span className="sb-spacer" />
        <span className="sb-muted">{donation.mealCount} meals</span>
      </div>
      {donation.description && (
        <p className="sb-muted" style={{ margin: "6px 0 0" }}>
          {donation.description}
        </p>
      )}
      {actions && (
        <div className="sb-row" style={{ marginTop: 8 }}>
          {actions}
        </div>
      )}
    </div>
  );
}
